module.exports = __webpack_public_path__ + "img/ico-1.a2943246.svg";